import blog from "./blog";
import blog_slider from "./blog_slider";
import blog_sorting from "./blog_sorting";
import changeImagesOnScroll from "./changeImagesOnScroll";
import faq from "./faq";
import menu from "./menu";
import mini_contact_form from "./mini_contact_form";
import modals from "./modals";
import slider from "./slider";
import tabs from "./tabs";
import feedback_form from "./feedback_form";

export default function app() {
    document.addEventListener('DOMContentLoaded', () => {
        changeImagesOnScroll();
        menu();
        tabs();
        faq();
        slider();
        blog();
        modals();
        feedback_form();
        mini_contact_form();

        const phone_input = document.querySelectorAll('.phone_input');
        phone_input.forEach(element => {
            element.addEventListener('focus', () => {
                if (!element.value.startsWith('+')) {
                    element.value = '+' + element.value;
                }

                element.addEventListener('input', () => {
                    const countryCode = element.value.slice(0, 3);
                    let maxLength;

                    switch (true) {
                        case element.value.startsWith('+1'):  // USA/Canada
                            maxLength = 12; // +1 + 10 digits
                            break;
                        case element.value.startsWith('+44'): // UK
                            maxLength = 13; // +44 + 9 digits
                            break;
                        case element.value.startsWith('+49'): // Germany
                            maxLength = 14; // +49 + 10 digits
                            break;
                        case element.value.startsWith('+33'): // France
                            maxLength = 12; // +33 + 8 digits
                            break;
                        case element.value.startsWith('+380'): // Ukraine
                            maxLength = 13; // +380 + 9 digits
                            break;
                        case element.value.startsWith('+34'): // Spain
                            maxLength = 12; // +34 + 8 digits
                            break;
                        case element.value.startsWith('+39'): // Italy
                            maxLength = 13; // +39 + 9 digits
                            break;
                        case element.value.startsWith('+31'): // Netherlands
                            maxLength = 12; // +31 + 8 digits
                            break;
                        case element.value.startsWith('+32'): // Belgium
                            maxLength = 12; // +32 + 8 digits
                            break;
                        case element.value.startsWith('+46'): // Sweden
                            maxLength = 12; // +46 + 8 digits
                            break;
                        case element.value.startsWith('+47'): // Norway
                            maxLength = 11; // +47 + 7 digits
                            break;
                        case element.value.startsWith('+45'): // Denmark
                            maxLength = 11; // +45 + 7 digits
                            break;
                        case element.value.startsWith('+358'): // Finland
                            maxLength = 13; // +358 + 9 digits
                            break;
                        case element.value.startsWith('+43'): // Austria
                            maxLength = 13; // +43 + 9 digits
                            break;
                        case element.value.startsWith('+41'): // Switzerland
                            maxLength = 12; // +41 + 8 digits
                            break;
                        case element.value.startsWith('+351'): // Portugal
                            maxLength = 13; // +351 + 9 digits
                            break;
                        case element.value.startsWith('+353'): // Ireland
                            maxLength = 13; // +353 + 9 digits
                            break;
                        case element.value.startsWith('+48'): // Poland
                            maxLength = 12; // +48 + 8 digits
                            break;
                        case element.value.startsWith('+420'): // Czech Republic
                            maxLength = 13; // +420 + 9 digits
                            break;
                        default:
                            maxLength = 15; // Default max length
                    }

                    if (element.value.length > maxLength) {

                        element.value = element.value.slice(0, maxLength);
                    }
                });
            });
        });
    })
}



